import React from "react";
import { IMG } from "@/lib/assets";

const services = [
  {
    n: "01",
    title: "Workflow Automation",
    desc: "Your apps talk to each other, so repeat tasks like new-client paperwork and invoices get done on their own.",
  },
  {
    n: "02",
    title: "Outreach & Follow-Up Systems",
    desc: "Friendly, personal emails and texts go out to leads and customers on time, so no one slips through the cracks.",
  },
  {
    n: "03",
    title: "Data Pipeline Automation",
    desc: "Your customer and sales info gathered and tidied up in one place, with no copy-and-paste.",
  },
  {
    n: "04",
    title: "Operations Automation",
    desc: "Scheduling, approvals, and updates handled for you, so your team can focus on the work that matters.",
  },
  {
    n: "05",
    title: "AI-Powered Analytics",
    desc: "Simple, up-to-date reports that show how your business is doing, explained in plain English.",
  },
  {
    n: "06",
    title: "Custom App Build",
    desc: "Need something that doesn't exist yet? We build an app made just for your business, your team, and your customers.",
  },
];

export default function Services() {
  return (
    <section id="services" className="relative py-14 sm:py-20">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 mb-10 items-end">
          <div className="lg:col-span-5">
            <span className="num-tile">What We Solve</span>
            <h2 className="font-serif font-medium text-[var(--ink)] text-[40px] sm:text-[54px] leading-[1.05] mt-5">
              AI Autopilot for your{" "}
              <span className="italic font-italic-serif text-[var(--ink-soft)]">busywork</span>.
            </h2>
            <p className="mt-6 text-[16px] leading-[1.65] text-[var(--ink-soft)] max-w-[480px]">
              Smart tools that take the busywork off your plate. For bigger
              projects, we connect your systems and build custom apps. Any
              industry, from construction to spas.
            </p>
          </div>

          {/* Photo insert — hands + notebook + workflow */}
          <div className="lg:col-span-7">
            <figure className="lift relative rounded-2xl overflow-hidden border border-[var(--line)] aspect-[16/8]">
              <img
                src={IMG.dashboard}
                alt="Live analytics dashboard on a laptop screen"
                loading="lazy"
                className="w-full h-full object-cover"
                style={{ filter: "saturate(0.95) contrast(1.02)" }}
              />
              {/* warm duotone wash to match brand */}
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(140deg, rgba(255,255,255,0.25) 0%, transparent 45%, rgba(120,145,185,0.25) 100%)",
                  mixBlendMode: "soft-light",
                }}
              />
              {/* corner labels */}
              <figcaption className="absolute top-4 left-4">
                <span className="glass rounded-full px-3 py-1 font-mono text-[10px] tracking-[0.22em] uppercase text-[var(--ink)]">
                  Live · Production
                </span>
              </figcaption>
            </figure>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {services.map((s, i) => {
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="lift group relative bg-white border border-[var(--line)] rounded-2xl px-6 py-5 overflow-hidden"
              >
                <h3 className="font-serif text-[20px] text-[var(--ink)] leading-tight mb-2">
                  {s.title}
                </h3>
                <p className="text-[14px] leading-[1.55] text-[var(--ink-muted)]">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
